interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("left-gap");
  for (let index = start; index <= end; index += 1) pages.push(index);
  if (end < total - 1) pages.push("right-gap");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = buildPages(page, total);
  const baseClass =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-2 text-sm transition-colors";

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-1.5">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${baseClass} ${
          page <= 1
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) => {
        if (typeof item === "string") {
          return (
            <span key={item} className="px-1 text-sm text-foreground-400">
              ...
            </span>
          );
        }
        const active = item === page;
        return (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${baseClass} ${
              active
                ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        );
      })}

      <button
        type="button"
        disabled={page >= total}
        onClick={() => onChange(page + 1)}
        className={`${baseClass} ${
          page >= total
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}